import Demonstration from './components/Demonstration';

import UserReviews from './components/UserReviews';
import { prompts } from '~/services';
import { Link } from '@remix-run/react';
import { ArrowRight } from 'lucide-react';
import { AlternativeToSection, IntegrationsList } from '~/routes/_public.chatgpt-for-microsoft-word';
import { EmblaCarouselForReviews } from '~/components/EmblaCarousel';
import { Button } from '../ui/button';

function AiToolCard({ prompt }) {
    return (
        <Link
            className='bg-white group block overflow-hidden w-full border border-1 rounded-xl hover:border-blue-600'
            to={`/tools/${prompt.type}/${prompt.id}`}>
            <div className='flex flex-col p-4 gap-4'>
                <div className='w-full gap-2 flex items-center justify-start'>
                    <span className='text-3xl'>{prompt.emoji}</span>
                    <p className='text-ellipsis max-w-64 whitespace-nowrap overflow-hidden mt-2  text-gray-900 sm:mt-3 text-lg md:text-xl font-pj'>
                        {prompt.title}
                    </p>
                </div>
                <p className='text-gray-600 h-20'>{prompt.description}</p>
                <Button variant='outline'>
                    Try Now
                    <ArrowRight />
                </Button>
            </div>
        </Link>
    );
}

export function AiToolsList({ title = 'Over 60 AI tools included' }) {
    return (
        <section className='py-12 bg-gray-50 sm:py-16 lg:py-20'>
            <div className='px-4 mx-auto max-w-7xl sm:px-6 lg:px-8'>
                <div className='max-w-xl mx-auto text-center xl:max-w-3xl'>
                    <h2 className='text-3xl font-bold text-gray-900 sm:text-4xl xl:text-5xl font-pj'>
                        {title}
                    </h2>
                </div>
            </div>

            <div className='mt-9 lg:mt-12 mx-4'>
                <EmblaCarouselForReviews
                    showDotControls={false}
                    slides={prompts.map((p) => (
                        <AiToolCard key={`prompt-${p.id}`} prompt={p} />
                    ))}
                />
            </div>

            <div className='px-4 mx-auto mt-2 lg:mt-4 max-w-7xl sm:px-6 lg:px-8'>
                <div className='text-center'>
                    <Link
                        to='/tools'
                        title='Check all 60+ AI Tools'
                        className='inline-flex items-center pb-2 text-base leading-7 text-gray-600 transition-all duration-200  hover:text-gray-900 font-pj focus:outline-none focus:ring-1 focus:ring-gray-900 focus:ring-offset-2 '>
                        Check all 60+ AI Tools{' '}
                        <ArrowRight className='ml-1 h-4' />
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default function Index() {
    return (
        <>
            <IntegrationsList title='Add ChatGPT into' />
            <Demonstration />
            <UserReviews />
            <AiToolsList />
            <AlternativeToSection />
        </>
    );
}
